module.exports = __webpack_public_path__ + "img/max-file-content-signature-add.de1f776c.svg";